import {useEffect, useRef} from "react";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

interface IUseWebOtpOptions {
    enabled: boolean;
    onCodeReceived: (code: string) => void;
}

interface OTPCredential extends Credential {
    code: string;
}

const isWebOtpSupported = (): boolean => {
    return typeof window !== "undefined" && "OTPCredential" in window;
};

export const useWebOtp = ({enabled, onCodeReceived}: IUseWebOtpOptions) => {
    const abortControllerRef = useRef<AbortController | null>(null);
    const onCodeReceivedRef = useRef(onCodeReceived);
    onCodeReceivedRef.current = onCodeReceived;

    useEffect(() => {
        if (!enabled || !isWebOtpSupported()) {
            return;
        }

        abortControllerRef.current?.abort();

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        const credentialRequestOptions = {
            otp: {transport: ["sms"]},
            signal: abortController.signal
        };

        navigator.credentials
            .get(credentialRequestOptions as CredentialRequestOptions)
            .then((credential) => {
                if (credential && "code" in credential) {
                    onCodeReceivedRef.current((credential as OTPCredential).code);
                }
            })
            .catch((error: Error) => {
                if (error.name !== "AbortError") {
                    notifyBugsnagClient(error, "WebOTP: failed to receive OTP code");
                }
            });

        return () => {
            abortController.abort();
            abortControllerRef.current = null;
        };
    }, [enabled]);
};
import {useEffect, useRef} from "react";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

interface IUseWebOtpOptions {
    enabled: boolean;
    onCodeReceived: (code: string) => void;
}

interface OTPCredential extends Credential {
    code: string;
}

const isWebOtpSupported = (): boolean => {
    return typeof window !== "undefined" && "OTPCredential" in window;
};

export const useWebOtp = ({enabled, onCodeReceived}: IUseWebOtpOptions) => {
    const abortControllerRef = useRef<AbortController | null>(null);
    const onCodeReceivedRef = useRef(onCodeReceived);
    onCodeReceivedRef.current = onCodeReceived;

    useEffect(() => {
        if (!enabled || !isWebOtpSupported()) {
            return;
        }

        abortControllerRef.current?.abort();

        const abortController = new AbortController();
        abortControllerRef.current = abortController;

        const credentialRequestOptions = {
            otp: {transport: ["sms"]},
            signal: abortController.signal
        };

        navigator.credentials
            .get(credentialRequestOptions as CredentialRequestOptions)
            .then((credential) => {
                if (credential && "code" in credential) {
                    onCodeReceivedRef.current((credential as OTPCredential).code);
                }
            })
            .catch((error: Error) => {
                if (error.name !== "AbortError") {
                    notifyBugsnagClient(error, "WebOTP: failed to receive OTP code");
                }
            });

        return () => {
            abortController.abort();
            abortControllerRef.current = null;
        };
    }, [enabled]);
};
